export const addStylesToHtml = () => {
  document.documentElement.style.width = '100%';
  document.documentElement.style.height = '100%';
  document.documentElement.style.minHeight = '100%';
  document.documentElement.style.margin = '0';
  document.documentElement.style.userSelect = 'none';
  document.documentElement.style.overscrollBehavior = 'none';
};
